import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { PrefixSimplifiedType } from '../../interfaces/Prefix'
import { getCollections } from '../../../httpClient/Requests/Api/TEMPO/system'
import { Lookup } from '../../../httpClient/interfaces/Lookup'
import { LookupState } from '../../interfaces/LookupState'

export const initialState: LookupState = {
    data: [],
    loading: false,
    error: null,
}

export const fetchCollections = (prefix: PrefixSimplifiedType) =>
    createAsyncThunk(`${prefix}/collection/fetchCollections`, async () => {
        let collections: Lookup[] = []
        if (prefix.includes('TEMPO')) {
            const response = await getCollections()
            collections = response.data
        }
        return collections
    })

const collectionsSlice = (prefix: PrefixSimplifiedType) =>
    createSlice({
        name: `${prefix}/collections`,
        initialState,
        reducers: {},
        extraReducers: (builder) => {
            builder.addCase(fetchCollections(prefix).pending, (state) => ({ ...state, loading: true, error: null }))
            builder.addCase(fetchCollections(prefix).fulfilled, (state, action) => ({
                ...state,
                data: action.payload,
                loading: false,
                error: null,
            }))
            builder.addCase(fetchCollections(prefix).rejected, (state, action) => ({
                ...state,
                loading: false,
                error: action.error,
            }))
        },
    })

const collections = (prefix: PrefixSimplifiedType) => collectionsSlice(prefix).reducer

export default collections
